import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import WStoreConfirmationNew from 'containers/WStorePage/WStoreModalNew/WStoreConfirmationNew';
import LoadingIndicator from 'components/LoadingIndicator';
import CloseIcon from 'resources/X_close_icon.png';
import PurpleWIcon from 'resources/PurpleW.png';
import SapphireIcon from 'resources/icons-currency-sapphire-sml.png';
import WScoreIcon from 'resources/ui-icon-wscore.png';
import {
  getAvailableInfo,
  getCategoryItemClassName,
  getStockInfo,
  getValidityString,
  isPurchaseEnabled
} from '../../WStoreUtils';
import './WStorePurchaseModalNew.css';

class WStorePurchaseModalNew extends Component {
  renderPurchaseBody() {
    const { selectedItem, purchaseRequested } = this.props;

    const availableInfo = getAvailableInfo(selectedItem.wstoreItemCount);
    const stockInfo = getStockInfo(selectedItem.wstoreItemCount, true);
    const inStockText = stockInfo === 'Unlimited' ? 'in Stock' : '';

    return (
      <React.Fragment>
        <div className="body-row">
          <div className="valid-dates">{getValidityString(selectedItem)}</div>
          <div className="item-count-validity">
            {availableInfo}
            {availableInfo && stockInfo && '|'}
            {stockInfo}
            {inStockText}
          </div>
        </div>
        <div className="wscore-info">
          <img src={WScoreIcon} alt="WScore" />
          <div className="wscore-cost">{`WScore: ${selectedItem.wscore}`}</div>
          {selectedItem.sapphireCost && (
            <>
              <div className="cost-separator">+</div>
              <img src={SapphireIcon} alt="Sapphire" />
              <div>{`Sapphires: ${selectedItem.sapphireCost}`}</div>
            </>
          )}
        </div>
        <div className="item-description">{selectedItem.description}</div>
        {purchaseRequested && <LoadingIndicator overlay />}
      </React.Fragment>
    );
  }

  renderRedeemButton() {
    const { selectedItem, patronAssets, onPurchase } = this.props;
    const disabled = !isPurchaseEnabled(selectedItem, patronAssets);
    const buttonClass = `redeem-button${disabled ? '-disabled' : ''}`;

    return (
      <button
        className={buttonClass}
        type="button"
        onClick={onPurchase}
        disabled={disabled}
      >
        Redeem
      </button>
    );
  }

  renderValidText() {
    const { selectedItem } = this.props;
    const { claimStartDate, claimEndDate, locations } = selectedItem;

    const isValidForOneDay = claimEndDate === claimStartDate;
    const validDates = isValidForOneDay
      ? claimEndDate
      : `${claimStartDate} - ${claimEndDate}`;

    const validText = `Valid only on ${validDates} at `;
    const locationText = locations.includes('All')
      ? 'any Wind Creek Location'
      : `Wind Creek ${locations.join(', ')}`;

    return (
      <div className="valid-location-text">
        {validText}
        {locationText}
      </div>
    );
  }

  render() {
    const { selectedItem, hidden, onClose, purchaseConfirmation } = this.props;
    const show = selectedItem && !hidden;
    return (
      show && (
        <Modal
          className={`modal-dialog-wstore-new ${
            purchaseConfirmation ? 'modal-overlay' : ''
          }`}
          show={true}
          onHide={onClose}
        >
          <Modal.Body
            bsPrefix={`modal-body ${getCategoryItemClassName(
              selectedItem.classCode
            )}`}
          >
            <button
              className="exit-modal-button"
              type="button"
              onClick={onClose}
            >
              <img src={CloseIcon} alt="Close purchase modal" />
            </button>
            <img
              className="item-image"
              src={selectedItem.imageUrl || PurpleWIcon}
              alt={selectedItem.name}
            />
            <div className="current-location">
              {this.props.preferredLocation}
            </div>
            <div className="title">{selectedItem.name}</div>
            {this.renderPurchaseBody()}
            {this.renderRedeemButton()}
            {purchaseConfirmation && (
              <WStoreConfirmationNew isQuestItem={false} {...this.props} />
            )}
            {this.renderValidText()}
          </Modal.Body>
        </Modal>
      )
    );
  }
}

WStorePurchaseModalNew.propTypes = {
  selectedItem: PropTypes.object,
  patronAssets: PropTypes.any,
  onPurchase: PropTypes.func,
  purchaseRequested: PropTypes.bool,
  purchaseConfirmation: PropTypes.bool,
  purchaseResponseMsg: PropTypes.string,
  purchaseEmailMsg: PropTypes.string,
  hidden: PropTypes.bool,
  onClose: PropTypes.func
};

export default WStorePurchaseModalNew;
